var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBottomCenter = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1507 19.9365L3.24573 19.9365C2.78641 19.9365 2.41406 20.3089 2.41406 20.7682C2.41406 21.2275 2.78641 21.5999 3.24573 21.5999L21.1507 21.5999C21.6098 21.5999 21.9824 21.2273 21.9824 20.7682C21.9824 20.3091 21.6098 19.9365 21.1507 19.9365Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9836 14.605L12.9836 4.03867C12.9836 3.54161 12.5806 3.13867 12.0836 3.13867C11.5865 3.13867 11.1836 3.54162 11.1836 4.03867L11.1836 14.605L8.48359 14.605L12.0836 18.196L15.6836 14.605L12.9836 14.605Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBottomCenter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bottom-center.320be8f5.svg";
export { ForwardRef as ReactComponent };